import React from "react";

interface ComponentProps {
  json: {
    title?: string;
    description?: string;
    img?: {
      mediaAsset: string;
      link: string;
    };
  };
}

type Props = ComponentProps;

export const OurNorthSatrPanel = (props: Props) => {
  return null;
};
